module.exports = __webpack_public_path__ + "img/1.Grooming.af2310a3.jpg";